import { render, staticRenderFns } from "./RegistrationStepThreeCompany.vue?vue&type=template&id=18ae3e27&scoped=true&"
import script from "./RegistrationStepThreeCompany.vue?vue&type=script&lang=js&"
export * from "./RegistrationStepThreeCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae3e27",
  null
  
)

export default component.exports